import { PlatformEnum } from "@/enums/PlatformEnum"
import httpClient from "./HttpClient"

export default {
    async auth() {
        httpClient.get('/auth')
    },

    async init() {
        return httpClient.post('general/init/' + PlatformEnum.ID_DROPOFF)
    },
}
